import { atom, useAtom } from "jotai";

export const isTimeSyncWarningDismissedAtom = atom(false);

export const useIsTimeSyncWarningDismissed = () => {
  const [isTimeSyncWarningDismissed, setIsTimeSyncWarningDismissed] = useAtom(
    isTimeSyncWarningDismissedAtom,
  );

  return {
    isTimeSyncWarningDismissed,
    setIsTimeSyncWarningDismissed,
  };
};
